export enum Service {
    X_SERIES = "x-series",
}
